import script from "./Search.vue?vue&type=script&setup=true&lang=js"
export * from "./Search.vue?vue&type=script&setup=true&lang=js"

import "./Search.vue?vue&type=style&index=0&id=157ed870&lang=scss"

const __exports__ = script;

export default __exports__